import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import { TabItemType } from './hooks/useTab';

/**
 * 求人詳細とPRのタブを切り替えるコンポーネントのProps
 */
interface TabProps {
  /** タブのスタイルを上下逆にするかどうか */
  isUpsideDown?: boolean;
  /** タブ要素の持つプロパティの配列 */
  tabItems: TabItemType[];
}

const getTabItemClass = (isSelected: boolean) =>
  classNames(styles['jobSearchDetail-tabArea__tab__item'], {
    [styles['jobSearchDetail-tabArea__tab__item--selected']]: isSelected,
  });

/**
 * 求人詳細とPRのタブを切り替えるコンポーネント。
 */
export const Tab: React.FC<TabProps> = ({ isUpsideDown = false, tabItems }) => {
  return (
    <>
      <div
        className={classNames(styles['jobSearchDetail-tabArea__tab'], {
          [styles['jobSearchDetail-tabArea__tab--upsideDown']]: isUpsideDown,
        })}
      >
        {tabItems.map(({ href, onClick, name, isSelected }) => (
          <TabItem
            key={name}
            name={name}
            href={href}
            onClick={onClick}
            isSelected={isSelected}
          />
        ))}
      </div>
    </>
  );
};

const TabItem: React.FC<TabItemType> = ({
  name,
  isSelected,
  onClick,
  href,
}) => {
  if (isSelected)
    return <span className={getTabItemClass(isSelected)}>{name}</span>;
  return (
    <a href={href} className={getTabItemClass(isSelected)} onClick={onClick}>
      {name}
    </a>
  );
};
